import simpleFetch from "../../../../../../utils/simpleFetch";

class WithdrawalEmailTemplateApi {
  static getTemplate(path, body, headers) {
    return simpleFetch("post", path, { body, headers });
  }
}

export default WithdrawalEmailTemplateApi;



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/withdrawal-configuration/withdrawalEmailTemplateApi.js